// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3n1V6","tab":"Tabs_tab__2Gsqi","tabActive":"Tabs_tabActive__2QMgz"};